var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "cbb4beb2aa86687c81fe8ad8f9b5f054b5e8a286"
};